module.exports = __webpack_public_path__ + "img/GabrielleNadeauArt-Monster-Under-table-640.9035b9cf.jpg";